import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponentComponent } from './login-component/login-component.component';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginFormComponent } from './login-form/login-form.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { LinkSentSuccessfullyComponent } from './link-sent-successfully/link-sent-successfully.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { PasswordResetSuccessfullyComponent } from './password-reset-successfully/password-reset-successfully.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { HttpClientModule } from '@angular/common/http';
import { PreLoginComponent } from './pre-login/pre-login.component';

@NgModule({
  declarations: [
    LoginComponentComponent,
    LoginFormComponent,
    ForgetPasswordComponent,
    LinkSentSuccessfullyComponent,
    ResetPasswordComponent,
    PasswordResetSuccessfullyComponent,
    PreLoginComponent  
  ],
  imports: [
    CommonModule,
    LoginRoutingModule,
    ReactiveFormsModule,
    MaterialModule,
    HttpClientModule,
  ]
})

export class LoginModuleModule { }
